import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { useStyles, chakra } from '@chakra-ui/react';
import React__default from 'react';
import { dataAttr } from '@chakra-ui/utils';
var _excluded = ["isCurrentStep"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var StepIndicatorDot = function StepIndicatorDot(props) {
  var styles = useStyles();
  var isCurrentStep = props.isCurrentStep,
    rest = _objectWithoutProperties(props, _excluded);
  var dotStyles = _objectSpread({
    position: 'relative',
    zIndex: 2
  }, styles.dot);
  return /*#__PURE__*/React__default.createElement(chakra.div, _extends({
    className: "chakra-step-indicator-dot",
    "data-current": dataAttr(isCurrentStep),
    __css: dotStyles
  }, rest));
};
export { StepIndicatorDot };